import store from 'src/store';
import { setDataModalKeepWatching } from 'src/actions/modalKeepWatching';

interface ISetValuesStore {
    comeThisModal?: boolean;
    groupId?: string;
    nextGroupId?: string;
    modalPropsOptionsEpisodes?: unknown;
}

const setValuesStoreModalKeepWatching = (data: ISetValuesStore): void => {
    const infoModalNow = store.getState().modalKeepWatching;
    store.dispatch(setDataModalKeepWatching({ ...infoModalNow, ...data }));
};
const getUrlRedirectBack = (defaultRedirect: string): string => {
    const comeModalKeepWatching = store.getState().modalKeepWatching.comeThisModal;
    const groupId = store.getState().modalKeepWatching.groupId;
    const urlRedirect = comeModalKeepWatching ? `/vcard/${groupId}/1` : defaultRedirect;
    setValuesStoreModalKeepWatching({ comeThisModal: false, groupId: '', nextGroupId: '' });
    return urlRedirect;
};

export { setValuesStoreModalKeepWatching, getUrlRedirectBack };



// WEBPACK FOOTER //
// ./src/components/Modal/functions/ModalKeepWatching/functions.ts